import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.58601 13.1722C8.16748 13.1722 9.61877 12.6148 10.7541 11.6857L14.8751 15.8067C15.1333 16.065 15.5492 16.0639 15.8064 15.8067C16.0654 15.5477 16.0636 15.1325 15.8065 14.8753L11.6855 10.7543C12.6146 9.61894 13.172 8.16763 13.172 6.58612C13.172 2.94871 10.2234 0 6.58601 0C2.94866 0 0 2.94871 0 6.58612C0 10.2235 2.94866 13.1722 6.58601 13.1722ZM11.855 6.58613C11.855 9.49606 9.49607 11.855 6.58619 11.855C3.67631 11.855 1.31738 9.49606 1.31738 6.58613C1.31738 3.6762 3.67631 1.31723 6.58619 1.31723C9.49607 1.31723 11.855 3.6762 11.855 6.58613Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/search.svg
// module id = XlzG
// module chunks = 258